var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{staticClass:"site-content",class:{ 'site-content--tabs': _vm.$route.meta.isTab }},[(_vm.$store.state.showTestFlag)?_c('el-alert',{attrs:{"title":"当前运行环境：测试环境","type":"error","closable":false}}):_vm._e(),_c('div',{style:(_vm.siteContentViewHeight)},[_c('router-view',{key:_vm.key})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }